import { Component, OnInit } from "@angular/core";
import { ContactInformationsService } from "../../Services/contact-informations.service";
import { ContactInformations } from "../../Models/Contact-informations";

@Component({
    selector: "app-client-service-card",
    templateUrl: "./client-service-card.component.html",
    styleUrls: ["./client-service-card.component.scss"],
    standalone: false
})
export class ClientServiceCardComponent implements OnInit {
  contactInformation?: ContactInformations;

  constructor(private contactInformationsService: ContactInformationsService) {}

  ngOnInit(): void {
    this.contactInformationsService
      .getContactInformations()
      .subscribe((res) => {
        this.contactInformation = res;
      });
  }
}
